/**
 * Checks if a promise is fulfilled and returns its value if so.
 *
 * @template T The type of the promise's resolved value.
 * @param {PromiseSettledResult<T>} data - The settled promise result to check.
 * @returns {T | null} The value of the fulfilled promise, or null if not fulfilled.
 * @example
 * const results = await Promise.allSettled([promise1, promise2]);
 * const validResults = results.map(isPromiseFullfilled).filter(Boolean);
 */
export const isPromiseFullfilled = <T>(data: PromiseSettledResult<T>) =>
  data.status === 'fulfilled' ? data.value : null
